<template>
    <div>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Edit Quiz
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
        </v-card>
    </div>
</template>
<script>
    export default {
        components: {
           
        },
        data() {
            return {
              
            }
        },
       methods:{
            onload(){
               
            }
        },
        mounted(){
            this.onload()
        }
    };
</script>
<style scoped>
</style>
